import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { FileDescriptorModule } from '../file-descriptor/file-descriptor.module';
import { SharedModule } from '../../shared/shared.module';
import { DialogModalComponent } from '../../shared/components/dialog-modal/dialog-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { VerificationRouterModule } from "./verification.routing";
import { VerificationComponent } from './pages/verification/verification.component';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        VerificationRouterModule,
        ReactiveFormsModule,
        FileDescriptorModule,
        SharedModule,
        NgSelectModule,
        NgxLoadingModule
    ],
    exports: [],
    declarations: [VerificationComponent],
    providers: [],
    entryComponents: [DialogModalComponent]
})
export class VerificationModule { }